import { Link } from 'react-router-dom';

const footerLinks = {
  navigation: [
    { label: '首页', path: '/' },
    { label: '分类浏览', path: '/category/dianshiju' },
    { label: '使用指南', path: '/article/mogu-video-web-version-access-guide' },
    { label: '关于我们', path: '/about' },
  ],
  categories: [
    { label: '电视剧', path: '/category/dianshiju' },
    { label: '电影', path: '/category/dianying' },
    { label: '综艺', path: '/category/zongyi' },
    { label: '动漫', path: '/category/dongman' },
    { label: '纪录片', path: '/category/jilupian' },
    { label: '短剧', path: '/category/duanju' },
  ],
  support: [
    { label: '常见问题', path: '/article/mogu-video-web-playback-issues-fix' },
    { label: '安全隐私', path: '/article/mogu-video-web-security-privacy' },
    { label: '访问指南', path: '/article/mogu-video-web-version-access-guide' },
    { label: '使用技巧', path: '/article/mogu-video-web-hidden-features' },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-secondary-500">
      <div className="w-full px-4 md:px-6 py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4 no-underline">
              <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-50/20">
                <i className="ri-play-circle-fill text-xl text-background-50"></i>
              </div>
              <span className="text-lg font-bold text-background-50 font-heading whitespace-nowrap">
                蘑菇视频
              </span>
            </Link>
            <p className="text-sm text-background-50/70 leading-relaxed mt-2">
              蘑菇视频网页版 - 无需下载App即可直接在浏览器观看海量视频，随时随地享受流畅的在线观影体验。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 font-label">快速导航</h4>
            <ul className="space-y-2.5">
              {footerLinks.navigation.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.path}
                    className="text-sm text-background-50/60 hover:text-background-50 transition-colors duration-200"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 font-label">热门分类</h4>
            <ul className="space-y-2.5">
              {footerLinks.categories.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.path}
                    className="text-sm text-background-50/60 hover:text-background-50 transition-colors duration-200"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 font-label">帮助支持</h4>
            <ul className="space-y-2.5">
              {footerLinks.support.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.path}
                    className="text-sm text-background-50/60 hover:text-background-50 transition-colors duration-200"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
            <div className="mt-5 space-y-2">
              <p className="text-sm text-background-50/50">
                <i className="ri-mail-line mr-2"></i>
                support@moguvideo.com
              </p>
              <p className="text-sm text-background-50/50">
                <i className="ri-time-line mr-2"></i>
                周一至周日 9:00 - 22:00
              </p>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-background-50/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-background-50/40">
            &copy; 2026 蘑菇视频网页版. 保留所有权利.
          </p>
          <div className="flex items-center gap-5">
            <Link to="/about" className="text-sm text-background-50/40 hover:text-background-50/70 transition-colors duration-200">
              关于我们
            </Link>
            <a href="#" className="text-sm text-background-50/40 hover:text-background-50/70 transition-colors duration-200">
              服务条款
            </a>
            <a href="#" className="text-sm text-background-50/40 hover:text-background-50/70 transition-colors duration-200">
              隐私政策
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}